import Token from './token'
import Form from './form'

export default {
  svg: 'clipboard_list',
  label: 'Update Lists',
  type: 'contact',
  action: 'list',
  form: Form,
  token: Token
}
